module.exports = __webpack_public_path__ + "img/PACE_low-fi.5b58d5c9.jpg";